import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/vehicleConstans';

const initialState = {
  vehicle: null,
  vin: null,
  loading: true,
};

const vehicleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VEHICLE:
      return {
        ...initialState,
      };
    case types.GET_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicle: payload,
      };
    case types.GET_VEHICLE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default vehicleReducer;
